import { z } from "zod";
import { BaseFirestoreWStatusTagsSchema } from "./firestore.schema";
import {
  PublicTeamMemberWContactSchema,
  TeamMemberWContactSchema,
} from "./teamMember.schema";

// Schemas

export const NumberFormatSchema = z.enum([
  "none",
  "decimal",
  "roman",
  "lowerRoman",
  "alpha",
  "lowerAlpha",
  "bullet",
  "bulletOpen",
  "squareBullet",
  "squareBulletOpen",
]);

export const LetterHeadSchema = BaseFirestoreWStatusTagsSchema.extend({
  viewName: z.string().optional(),
  name: z.string(),
  email: z.string(),
  website: z.string().optional(),
  phoneNumber: z.string(),
  logoUrl: z.string(),
  members: TeamMemberWContactSchema.array(),
  layout: z.string().optional(),
  theme: z.string().optional(),
  sectionNumbering: NumberFormatSchema.optional(),
  itemNumbering: NumberFormatSchema.optional(),
  nestNumbering: z.boolean().optional(),
});

export const PublicLetterHeadSchema = LetterHeadSchema.pick({
  _version: true,
  id: true,
  createdAt: true,
  createdBy: true,
  updatedAt: true,
  updatedBy: true,
  viewName: true,
  name: true,
  email: true,
  website: true,
  phoneNumber: true,
  logoUrl: true,
  members: true,
}).extend({
  members: PublicTeamMemberWContactSchema.array(),
});

// DTOs

export const CreateLetterHeadDtoSchema = LetterHeadSchema.partial();

export const PutLetterHeadDtoSchema = CreateLetterHeadDtoSchema;

export const PatchLetterHeadDtoSchema = CreateLetterHeadDtoSchema;
